
type TemperatureUnits = {
  c: string | undefined;
  f: string | undefined;
}

type PressureUnits = {
  pa: string | undefined;
  psi: string | undefined;
  mpa: string | undefined;
  ksi: string | undefined;
}


export type TemperatureConversionState = {
  temperature: TemperatureUnits;
  pressure: PressureUnits;
};

// Reducer
type ConversionCategory = keyof Pick<
  TemperatureConversionState,
  'temperature' | 'pressure'
>;

type UpdateUnitAction = {
  type: 'update_unit';
  payload: {
    category: ConversionCategory;
    updatedUnits: Record<string, string>; // contains both the input and converted unit(s)
  };
};

type ResetCategoryAction = {
  type: 'reset_category';
  payload: {
    category: ConversionCategory;
  };
};

type ConversionAction =
  | UpdateUnitAction
  | ResetCategoryAction;


export const temperatureConversionInitialState: TemperatureConversionState = {
  temperature: { c: undefined, f: undefined },
  pressure: { pa: undefined, psi: undefined, mpa: undefined, ksi: undefined },
};


export const temperatureConversionReducer = (
  state: TemperatureConversionState,
  action: ConversionAction
): TemperatureConversionState => {
  switch (action.type) {
    case 'update_unit': {
      const { category, updatedUnits } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          ...updatedUnits,
        },
      };
    }

    case 'reset_category': {
      const { category } = action.payload;
      const resetCategoryState = Object.keys(state[category]).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {} as Record<string, string | undefined>);

      return {
        ...state,
        [category]: resetCategoryState,
      };
    }

    default:
      return state;
  }
};
